'use client';
import React from 'react';
import { IProduct } from '@mybestbrands/types';
import { mapProductsToEcommerceItems, trackSSTEvent } from '@/app/utils/tracking';
import VisibilityTracker from '@/app/ui/components/tracking/visibilityTracker';
import { useTranslation } from 'next-i18next';
import ProductTitle from '@/app/ui/components/product/productTitle';
import styles from './../style.module.scss';

type Props = {
  item: IProduct;
  clickEvent?: string;
};

export const ListItemInformation = ({ item, clickEvent }: Props) => {
  const { t } = useTranslation(['common']);
  const { price, originalPrice, shippingCost, couponPrice, priorityCoupon } = item;
  const hasDiscount = originalPrice && originalPrice !== price;

  const trackingData = {
    currency: 'EUR',
    value: item.epc / 100,
    items: mapProductsToEcommerceItems([item], '', priorityCoupon?.end_date_utc),
  };

  const deliveryCost =
    shippingCost === null
      ? t('POSSIBLE_SHIPPING_COST')
      : shippingCost === 0
      ? t('FREE_SHIPPING')
      : `${t('SHIPPING')} ${shippingCost.centsToEuros()} €`;

  const renderPrice = () => {
    return (
      <>
        <span className={`me-2 ${hasDiscount && 'text-danger'} ${styles['price']}`}>{price.centsToEuros()} €</span>
        {hasDiscount && (
          <span className={`text-decoration-line-through me-2 ${styles['originalPrice']}`}>
            {originalPrice?.centsToEuros()} €
          </span>
        )}
      </>
    );
  };

  return (
    <>
      <div
        className="mb-1 mb-md-0 text-uppercase text-overflow-hidden line-height-1 fw-bold"
        style={{ fontSize: '0.9rem' }}>
        {item.brandName}
      </div>
      <div
        className="mb-1 mb-md-0 text-overflow-hidden line-height-1"
        onClick={() => trackingData && trackSSTEvent(clickEvent || 'product_card_product_name_click', trackingData)}>
        <ProductTitle product={item} />
      </div>
      <div>
        {renderPrice()}
        <span className="d-block text-black-50" style={{ fontSize: '0.625rem' }}>
          {deliveryCost}
        </span>
      </div>
      {trackingData && <VisibilityTracker eventName={'product_card_display'} data={trackingData} />}
    </>
  );
};
